// Contenuti del sito - separati per manutenibilità e SEO
// Testi riferiti a spazzacaminodavide.com — solo servizi di pulizia

export const CONTACTS = {
  phoneDisplay: "335 376764",
  phoneRaw: "+39335376764",
  whatsapp: "393353767640", // usa 39 senza + per wa.me
  whatsappMsg: "Ciao Davide, vorrei un preventivo per lo spazzacamino.",
  email: "agenzia.sogari@gmail.com",
  name: "Spazzacamino Davide",
  fullName: "Davide Sogari",
  association: "ANFUS - Associazione Nazionale Fumisti Spazzacamini",
  googleReviewsUrl: "https://share.google/dK9GY16MUN5vmM1hu",
};

export const SERVICES = [
  {
    id: "canna-fumaria-legna",
    title: "Pulizia canna fumaria a legna",
    desc: "Pulizia completa della canna fumaria: rimozione di fuliggine, catrame e residui di combustione.",
    icon: "Flame",
  },
  {
    id: "canna-fumaria-pellet",
    title: "Pulizia canna fumaria a pellet",
    desc: "Pulizia della canna fumaria di stufe e caldaie a pellet. La manutenzione della stufa spetta al centro assistenza autorizzato.",
    icon: "Zap",
  },
  {
    id: "camino",
    title: "Pulizia camino",
    desc: "Pulizia accurata del camino tradizionale per un tiraggio ottimale.",
    icon: "Home",
  },
  {
    id: "termo-camino",
    title: "Pulizia termo camino",
    desc: "Pulizia completa di termo camini, canna fumaria compresa.",
    icon: "Thermometer",
  },
  {
    id: "caldaia-legna",
    title: "Pulizia caldaia a legna",
    desc: "Pulizia del focolare e della canna fumaria di caldaie a legna.",
    icon: "Cog",
  },
  {
    id: "stufa-legna",
    title: "Pulizia stufa a legna",
    desc: "Pulizia interna, guarnizioni e canna fumaria di stufe a legna.",
    icon: "Wind",
  },
  {
    id: "termostufa",
    title: "Pulizia termostufa a legna",
    desc: "Pulizia completa di termostufe a legna e della relativa canna fumaria.",
    icon: "Droplets",
  },
  {
    id: "cucina-legna",
    title: "Pulizia cucina a legna",
    desc: "Interventi su cucine economiche e stufe cucina tradizionali.",
    icon: "ChefHat",
  },
  {
    id: "videoispezione",
    title: "Videoispezione canna fumaria",
    desc: "Video ispezione con telecamera per verificare lo stato della canna fumaria, con relazione tecnica per eventuale intubaggio da parte del vostro installatore di fiducia.",
    icon: "Video",
  },
  {
    id: "relazione-impianto",
    title: "Relazione sullo stato impianto",
    desc: "Relazione tecnica sullo stato di canna fumaria e impianto, utile per verifiche periodiche e documentazione assicurativa.",
    icon: "FileText",
  },
  {
    id: "antivolatili",
    title: "Installazione rete antivolatili",
    desc: "Applicazione di reti e cappelli antivolatili sulla sommità del camino.",
    icon: "Shield",
  },
  {
    id: "nidi",
    title: "Rimozione nidi vespe e calabroni",
    desc: "Rimozione in sicurezza di nidi da canne fumarie e coperture.",
    icon: "Bug",
  },
  {
    id: "installatori",
    title: "Servizi per installatori",
    desc: "Pulizia canne fumarie e supporto tecnico per installatori di stufe, caldaie e camini.",
    icon: "Building2",
  },
  {
    id: "barbecue",
    title: "Pulizia canna fumaria barbecue",
    desc: "Pulizia della canna fumaria di barbecue in muratura ed esterni.",
    icon: "Utensils",
  },
  {
    id: "fotovoltaico",
    title: "Pulizia pannelli fotovoltaici",
    desc: "Pulizia professionale dei pannelli in collaborazione con SolarClean, la ditta del figlio Manuel.",
    icon: "Sun",
  },
];

export const GALLERY = [
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/64423d9b-a943-4f61-be50-36ee26825027/FB_IMG_1708366763474.jpg",
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/59944796-03ae-4eca-99ec-eeab4f2f427b/20200912_084116.jpg",
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/c3bb4af4-be41-41ac-977f-598ef034cf1c/20250530_085348-COLLAGE.jpg",
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/6fcf42fc-676c-4abd-8868-bf04467e56b7/20250519_090541-COLLAGE.jpg",
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/1a73ceaa-eddc-41ad-b97a-d5e79a379715/20250530_110530.jpg",
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/e1336bbc-841d-4d78-8ebc-b2a5533690b5/900_sl_chicca_4.jpg",
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/71f03b1c-d6f7-4778-9323-cec4502b50a8/FB_IMG_1760890490534-COLLAGE.jpg",
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/8adb34f0-031b-49db-8cac-7650db5d188c/dopo.jpg",
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/36d7c584-7ba6-43bd-b9a2-bb1c070e705e/20250603_151318-COLLAGE.jpg",
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/9af87078-5466-4df7-a8fb-b9910c9b881d/20250530_141035.jpg",
  "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/cb3f7a3c-e073-4245-abda-aa273803fb70/20240113_131543.jpg",
];

export const CERTIFICATES = {
  anfus: "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/542901d6-e830-4b9f-8e4f-44158e610d3e/anfusCompleto2.jpg",
  attestato: "https://images.squarespace-cdn.com/content/v1/66f30ccf7b110542e8d7f24d/041c17b0-5935-4a76-8f24-4c5564640dc1/ATTESTATO%2BSOGARI_240218_092038.jpg",
};

export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_chimney-care-hub/artifacts/e4pm1qyy_FB_IMG_1708366763474.jpg";
export const FIREPLACE_IMAGE = "https://images.unsplash.com/photo-1687190917342-9fe4015e7729?w=1200&q=85";
export const SOLAR_IMAGE = "https://images.unsplash.com/photo-1655300283247-6b1924b1d152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxjbGVhbmluZyUyMHNvbGFyJTIwcGFuZWxzJTIwcm9vZnxlbnwwfHx8fDE3ODM5MjA3NzR8MA&ixlib=rb-4.1.0&q=85";

// Zone servite per SEO
export const AREAS = {
  modena: {
    slug: "modena",
    name: "Modena",
    subtitle: "Spazzacamino a Modena e provincia",
    intro: "Serviamo la città di Modena e tutta la sua provincia con interventi di pulizia canna fumaria, camini, stufe e caldaie a legna e pellet.",
    towns: [
      "Carpi","Sassuolo","Formigine","Castelfranco Emilia","Vignola","Mirandola","Maranello","Pavullo nel Frignano","Fiorano Modenese","Nonantola","Finale Emilia","Soliera","Castelnuovo Rangone","Spilamberto","Castelvetro di Modena","San Felice sul Panaro","Bomporto","Novi di Modena","Savignano sul Panaro","Campogalliano","Concordia sulla Secchia","Serramazzoni","Cavezzo","San Cesario sul Panaro","Medolla","Ravarino","San Prospero","Marano sul Panaro","Zocca","Bastiglia","Guiglia","Prignano sulla Secchia","San Possidonio","Montese","Camposanto","Fanano","Lama Mocogno","Sestola","Pievepelago","Montefiorino","Palagano","Frassinoro","Polinago","Fiumalbo","Montecreto","Riolunato"
    ],
  },
  bologna: {
    slug: "bologna",
    name: "Bologna",
    subtitle: "Spazzacamino a Bologna e provincia",
    intro: "Serviamo Bologna città e tutti i comuni della provincia con pulizia canna fumaria, videoispezione, installazione rete antivolatili e servizi per installatori.",
    towns: [
      "Imola","Casalecchio di Reno","San Lazzaro di Savena","Valsamoggia","San Giovanni in Persiceto","Castel San Pietro Terme","Zola Predosa","Budrio","Castel Maggiore","Pianoro","Medicina","Molinella","Castenaso","Sasso Marconi","Ozzano dell'Emilia","Crevalcore","Calderara di Reno","San Pietro in Casale","Anzola dell'Emilia","Granarolo dell'Emilia","Monte San Pietro","Argelato","Malalbergo","Minerbio","San Giorgio in Piano","Sala Bolognese","Vergato","Sant'Agata Bolognese","Pieve di Cento","Baricella","Alto Reno Terme","Marzabotto","Dozza","Castello d'Argile","Monzuno","Monterenzio","Castiglione dei Pepoli","Bentivoglio","Galliera","Gaggio Montano","Mordano","Castel Guelfo di Bologna","Loiano","San Benedetto Val di Sambro","Grizzana Morandi","Monghidoro","Casalfiumanese","Castel di Casio","Borgo Tossignano","Lizzano in Belvedere","Fontanelice","Castel d'Aiano","Camugnano","Castel del Rio"
    ],
  },
  "reggio-emilia": {
    slug: "reggio-emilia",
    name: "Reggio Emilia",
    subtitle: "Spazzacamino a Reggio Emilia e provincia",
    intro: "Interventi di pulizia in tutta la provincia di Reggio Emilia: canne fumarie, videoispezione, stufe e caldaie a legna e pellet.",
    towns: [
      "Correggio","Scandiano","Casalgrande","Castellarano","Guastalla","Rubiera","Novellara","Quattro Castella","Sant'Ilario d'Enza","Cadelbosco di Sopra","Montecchio Emilia","Castelnovo ne' Monti","Bibbiano","Cavriago","Bagnolo in Piano","Reggiolo","Luzzara","Albinea","Castelnovo di Sotto","San Martino in Rio","Poviglio","Fabbrico","Gualtieri","Rio Saliceto","San Polo d'Enza","Gattatico","Campagnola Emilia","Brescello","Boretto","Campegine","Casina","Toano","Ventasso","Vezzano sul Crostolo","Rolo","Carpineti","Canossa","Villa Minozzo","Viano","Baiso","Vetto"
    ],
  },
};
